import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  PaperProps,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { withStyles } from "@mui/styles";
import { JobDetail } from "pages/c-dad-user-data";
import { useStyles } from "./style";
import { AGGREGATIONDATALIST, AGGREGATIONVALUELIST } from '../../utility/constants';
import { autoCompleteSelectOptionsFormat, getAggregateValue, selectedListValues } from "utility/helper";
import { listItemProp } from "utility/types";
import MultiSelectAutoComplete from "shared-component/autocomplete-checkbox-multiple";
import DataFillToolTip from "./components/dataFillToolTipComponent";
import { AggregateToolTipContent, FillToolTipContent } from "./components/FillToolTipContent";

const CustomTooltip = withStyles((theme) => ({
  arrow: {
    fontSize: "14px", // Adjust the font size to change arrow size
  },
}))(Tooltip);

interface FillPageProps {
  userInputData: Array<string>, jobDetails: JobDetail[]
}

const DataPrep = (props: FillPageProps) => {
  const { userInputData, jobDetails } = props;
  const [fillSelectedValues, setFillSelectedValues] = useState<string[]>([]);
  const [aggregateSelectedValues, setAggregateSelectedValues] = useState<string[]>([]);
  const [tooltipText, setTooltipText] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [aggregateDataSelection, setAggregateDataSelection] = useState<string[]>([]);
  const [aggregateValueSelection, setAggregateValueSelection] = useState<string[]>([]);
  const [inputPercentage, setInputPercentage] = useState<any>(null)
  const [fillType, setFillType] = useState<string>('noFill');
  const style = useStyles();
  // const cDadFillDataJobTriggerData = {}
  // const cDadFaultData = {}
  const handleTooltipHover = (text: any) => {
    setTooltipText(text);
  };
  const [missingSelection, setMissingSelection] = useState<string>('');
  const [currentSelection, setCurrentSelection] = useState<string>('');
  const [nullCountOpen, setNullCountOpen] = useState<boolean>(false);
  function PaperComponent(props: PaperProps) {
    return (
      <Paper {...props} style={{ width: '30%' }} />
    );
  }

  function NullCountPaperComponent(props: PaperProps) {
    return (
      <Paper {...props} style={{ width: '50%', maxWidth: '700px' }} />
    );
  }

  const triggerFillDataJob = async () => {
    const params: any = [{ fill_type: fillType, groupBy: aggregateDataSelection, aggregation: aggregateValueSelection }, { title: 'job_type', value: 'Prepared Data' }];
    if (fillSelectedValues?.length > 0) {
      params[0]['fill_signals'] = fillSelectedValues
    }
    if (inputPercentage) {
      params[0]['percentile'] = inputPercentage
    }
    if (aggregateSelectedValues?.length > 0) {
      params[0]['agg_signals'] = aggregateSelectedValues
    }
    resetCurrentSelection()
  };

  const resetCurrentSelection = () => {
    setFillType('noFill');
    setFillSelectedValues([]);
    setAggregateSelectedValues([])
    setAggregateDataSelection([]);
    setAggregateValueSelection([]);
  }

  const submitBtnEnable = () => {
    if ((aggregateDataSelection?.length > 0 && aggregateValueSelection?.length > 0 && aggregateSelectedValues?.length > 0 && ((fillType === 'noFill' && fillSelectedValues?.length === 0) || (fillSelectedValues?.length > 0 && fillType !== 'noFill')))) {
      if ((aggregateValueSelection?.includes('perc_input') && inputPercentage === null)) {
        return true
      }
      return false;
    } else if ((fillSelectedValues?.length > 0 && fillType !== 'noFill' && (aggregateSelectedValues?.length === 0 && aggregateDataSelection?.length === 0 && aggregateValueSelection?.length === 0))) {
      return false
    } else {
      return true
    }
  }

  const handleFillSignalSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    setFillSelectedValues(
      value
    );
  }

  const handleAggregateSignalSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    setAggregateSelectedValues(
      value
    );
  }

  const handleFillSelection = () => {
    if (fillSelectedValues?.length === 0 || aggregateDataSelection?.length === 0) {
      setMissingSelection(fillSelectedValues?.length === 0 ? 'Fill Job' : 'Aggregate');
      setCurrentSelection(fillSelectedValues?.length > 0 ? 'Fill Job' : 'Aggregate');
      setModalOpen(true);
    } else {
      triggerFillDataJob()
    }

  }

  const handleAggregateDataSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    setAggregateDataSelection(value);

  }

  const handleAggregateValueSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    if ((value?.length > 0 && !value?.includes('perc_input')) || value?.length === 0) {
      setInputPercentage(null)
    }
    setAggregateValueSelection(value);
  }

  return (
    <Box>
      <Box
        sx={{
          display: {
            md: "flex",
            sm: "flex",
            xs: "none",
          },
        }}
        alignItems={"center"}
      >
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {jobDetails?.map((item: JobDetail) => (
              <Typography key={item.id} fontWeight={"600"}>
                <span>
                  {item.title}:{" "}
                </span>
                <span>
                  {item.value}
                </span>
              </Typography>
            ))}
          </div>
          {[]?.length > 0 ? <div><Button variant="text" onClick={() => setNullCountOpen(true)}>Please Click Here to see Signals with Null Count</Button></div> : null}
        </Box>
      </Box>
      {false ?
        <div className={style.overlay}>
          <div className={style.loader}></div>
        </div> :
        <div>
          <div style={{ display: 'flex' }}>
            <Paper
              elevation={2}
              sx={{
                margin: "10px",
                padding: '2%',
                width: '50%'
              }}
            >
              <div style={{ float: 'right' }}><DataFillToolTip content={FillToolTipContent} /></div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  paddingRight: "50px",
                  flexDirection: "column"
                }}
              >
                <div style={{ width: '75%' }}>
                  <FormLabel id="demo-row-radio-buttons-group-label" style={{ fontWeight: 'bold' }}>Select Channel: </FormLabel>
                  <FormControl style={{ width: '100%', marginTop: '10px' }}
                  >
                    {userInputData?.length > 0 && <MultiSelectAutoComplete
                      items={autoCompleteSelectOptionsFormat(userInputData)}
                      label="Select / Search Channels"
                      selectAllLabel="Select All"
                      onChange={(value: listItemProp[]) => {
                        handleFillSignalSelection(value)
                      }}
                    />}
                  </FormControl>
                </div>
                <div style={{ marginTop: '10px', display: 'flex', flexDirection: "column" }}>
                  <FormLabel id="demo-row-radio-buttons-group-label" style={{ fontWeight: 'bold' }}>Select Fill Type: </FormLabel>
                  <FormControl>
                    <div>
                      <RadioGroup defaultValue={fillType} value={fillType} name="radio-buttons-group">
                        <CustomTooltip arrow title={tooltipText} placement="left-start">
                          <FormControlLabel
                            value="forward"
                            control={<Radio />}
                            label="Fill With Forward Fill"
                            onMouseEnter={() =>
                              handleTooltipHover("Fill with Forward Fill")
                            }
                            onClick={() => {
                              setFillType('forward');
                            }}
                            onMouseLeave={() => handleTooltipHover("")}
                          />
                        </CustomTooltip>
                        <CustomTooltip arrow title={tooltipText} placement="left-start">
                          <FormControlLabel
                            value="backward"
                            control={<Radio />}
                            label="Fill With Backward Fill"
                            onMouseEnter={() =>
                              handleTooltipHover("Fill with Backward Fill")
                            }
                            onMouseLeave={() => handleTooltipHover("")}
                            onClick={() => {
                              setFillType('backward');
                            }}
                          />
                        </CustomTooltip>
                        <CustomTooltip arrow title={tooltipText} placement="left-start">
                          <FormControlLabel
                            value="interpolation"
                            control={<Radio />}
                            label="Fill With Interpolation"
                            onMouseEnter={() =>
                              handleTooltipHover("Fill with Interpolation")
                            }
                            onMouseLeave={() => handleTooltipHover("")}
                            onClick={() => {
                              setFillType('interpolation');
                            }}
                          />
                        </CustomTooltip>
                        <CustomTooltip arrow title={tooltipText} placement="left-start">
                          <FormControlLabel
                            value="noFill"
                            control={<Radio />}
                            label="No Fill"
                            onMouseEnter={() =>
                              handleTooltipHover("No Fill")
                            }
                            onMouseLeave={() => handleTooltipHover("")}
                            onClick={() => {
                              setFillType('noFill');
                            }}
                          />
                        </CustomTooltip>
                      </RadioGroup>
                    </div>
                  </FormControl>
                </div>
              </div>
            </Paper>
            <Paper
              elevation={2}
              sx={{
                margin: "10px",
                padding: '2%',
                width: '50%'
              }}
            >
              <div style={{ float: 'right' }}><DataFillToolTip content={AggregateToolTipContent} /></div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  paddingRight: "50px",
                }}
              >

                <div style={{ width: '75%' }}>
                  <FormLabel id="demo-row-radio-buttons-group-label" style={{ fontWeight: 'bold' }}>Select Channel: </FormLabel>
                  <FormControl style={{ width: '100%', marginTop: '10px' }}
                  >
                    {userInputData?.length > 0 && <MultiSelectAutoComplete
                      items={autoCompleteSelectOptionsFormat(userInputData)}
                      label="Select / Search Channels"
                      selectAllLabel="Select All"
                      onChange={(value: listItemProp[]) => {
                        // if (value?.length > 0) handleSignalSelection(value)
                        handleAggregateSignalSelection(value)
                      }}
                      
                    />}
                  </FormControl>

                </div>

              </div>
              <div className={style.dataAggregation}>
                <div>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    <Typography fontWeight={'bold'}>
                      How Would you like to aggregate your data?
                      <br />(Select all that apply)
                    </Typography></FormLabel>
                  <FormControl style={{ width: '67%', marginTop: '10px' }}
                  >
                    {userInputData?.length > 0 && <MultiSelectAutoComplete
                      items={AGGREGATIONDATALIST}
                      label="Group By"
                      selectAllLabel="Select All"
                      onChange={(value: listItemProp[]) => {
                        // if (value?.length > 0) handleSignalSelection(value)
                        handleAggregateDataSelection(value)
                      }}
                      
                    />}
                  </FormControl>
                </div>
                <div style={{ marginTop: '10px' }}>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    <Typography fontWeight={'bold'}>
                      How Would you like to aggregate your data?
                      <br />(Select all that apply)
                    </Typography></FormLabel>
                  <FormControl style={{ width: '67%', marginTop: '10px' }}
                  >
                    {userInputData?.length > 0 && <MultiSelectAutoComplete
                      items={AGGREGATIONVALUELIST}
                      label="Aggregate By"
                      selectAllLabel="Select All"
                      onChange={(value: listItemProp[]) => {
                        // if (value?.length > 0) handleSignalSelection(value)
                        handleAggregateValueSelection(value)
                      }}
                    />}
                  </FormControl>
                  {
                    aggregateValueSelection?.includes('perc_input') &&
                    <FormControl sx={{ marginTop: '10px', width: '25%', marginLeft: '10px' }} variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">{getAggregateValue('perc_input', AGGREGATIONVALUELIST)}</InputLabel>
                      <OutlinedInput
                        sx={{
                          height: '3.47rem'
                        }}
                        id="outlined-adornment-password"
                        endAdornment={
                          <InputAdornment position="end">
                            %
                          </InputAdornment>
                        }
                        label={getAggregateValue('perc_input', AGGREGATIONVALUELIST)}
                        size="small"
                        defaultValue={inputPercentage}
                        type="number"
                        onChange={(e: any) => {
                          const value = parseInt(e?.target?.value);
                          if (value) {
                            setInputPercentage(value)
                          } else {
                            setInputPercentage(null)
                          }
                        }}
                      />
                    </FormControl>
                  }
                </div>
              </div>
            </Paper>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
            <Button disabled={submitBtnEnable()} variant="contained" sx={{ maxWidth: "288px", width: "100%" }} onClick={() => handleFillSelection()}>
              SUBMIT
            </Button>
          </div>
        </div>
      }
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        PaperComponent={PaperComponent}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <IconButton
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            onClick={() => setModalOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', paddingTop: '20px !important' }}>
          <Typography fontWeight={'bold'}>{`Looks like you have only selected ${currentSelection} Data, Would you like to select ${missingSelection} Data ? (If YES Please select ${missingSelection} filters)`}</Typography>
        </DialogContent>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-around"}
          alignItems={"center"}
          padding={'2%'}
        >
          <Button variant='contained' style={{ width: '25%' }} onClick={() => { triggerFillDataJob(); setModalOpen(false) }}>No</Button>
          <Button variant='contained' style={{ width: '25%' }} onClick={() => { setModalOpen(false) }}>Yes</Button>
        </Box>
      </Dialog>
      <Dialog
        open={nullCountOpen}
        onClose={() => setNullCountOpen(false)}
        PaperComponent={NullCountPaperComponent}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <div style={{ display: 'flex', justifyContent: "space-between", width: '95%' }}>
            <Typography fontWeight={"bold"}>Signals with Null Count</Typography>
            <Typography fontWeight={"bold"}>{`Total Count: 40`}</Typography>
          </div>
          <IconButton
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            onClick={() => setNullCountOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ModalData data={{}} />
        </DialogContent>
      </Dialog>
    </Box>
  )
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ModalData = (props: any) => {
  const dataList: any = props?.data;
  const transformed = (dataList).map((item: any) => {
    return <div style={{ display: 'flex', justifyContent: "space-between" }}><div style={{ fontWeight: "bold", textAlign: "left" }}><span>{`${item?.Signal}:`}</span><br /><span>Percentage:</span></div><div><span>{`${item.nullCount}`}</span><br /> <span>{item?.Percentage[0]} %</span></div></div>
  })

  return (
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        {transformed &&
          transformed?.map((item: any, index: number) => {
            return (
              <Grid item xs={2} sm={4} md={dataList?.length === 2 ? 6 : 4} key={index}>
                <Item style={{ width: dataList?.length === 2 ? '16rem' : '' }}>{item}</Item>
              </Grid>
            )
          })}
      </Grid>
  );
};

export default DataPrep;